import send from './send';
import { eventsKeys } from '../constants';

export default () => {
  send(eventsKeys.QUICK_SIGNUP_SUCCEED, {
    type: 'quick signup',
  });
};
